import { createContext, useContext } from 'react';
import { FeatureFlagService, findFeatureValue, findFeatureVisibility } from '@nextgen-web-framework/core';
import type { FeatureFlag, Feature } from '@nextgen-web-framework/core';
import { FeatureFlagProviderInterface } from './types/propType';

const FeatureFlagContext = createContext<FeatureFlag>({} as FeatureFlag);

const FeatureFlagProvider = function ({ featureFlagData, children }: FeatureFlagProviderInterface) {
  FeatureFlagService?.setFeatureFlagData?.(featureFlagData);
  return <FeatureFlagContext.Provider value={featureFlagData}>{children}</FeatureFlagContext.Provider>;
};

const useFeatureValue = (key: string): Feature | null => {
  const featureMap = useContext(FeatureFlagContext);
  return findFeatureValue(featureMap, key);
};

const useFeatureVisibility = (key: string): boolean => {
  const featureMap = useContext(FeatureFlagContext);
  return findFeatureVisibility(featureMap, key);
};

export default FeatureFlagProvider;
export type { FeatureFlagProviderInterface };
export { useFeatureValue, useFeatureVisibility };
